var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "current-plan",
      class: { trialPlan: _vm.trialPlan },
      on: {
        click: function ($event) {
          return _vm.showPlans(_vm.type)
        },
      },
    },
    [
      _vm.trialPlan
        ? _c("div", { staticClass: "trial-plan" }, [
            _vm._v(_vm._s(_vm.$t("billing.free"))),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "current-plan-head" }, [
        _c("div", { staticClass: "current-plan-title" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$t("message.plans.types." + _vm.type.replace("-", "_"))
              ) +
              "\n\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              display: "grid",
              "grid-template-columns": "auto auto",
              "column-gap": "4px",
            },
          },
          [
            _vm.planAction
              ? _c("div", { staticClass: "current-plan-status" }, [
                  _vm._v(_vm._s(_vm.$t("billing.packageManagement"))),
                ])
              : _c("div", { staticClass: "current-plan-status" }, [
                  _vm._v(_vm._s(_vm.$t("billing.buyIt"))),
                ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "current-plan-body" }, [
        _c("div", { staticClass: "current-plan-details" }, [
          _c("div", { staticClass: "plan-detail" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      followCursor: true,
                      placement: "bottom-end",
                    },
                    expression:
                      "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                  },
                ],
                attrs: { content: _vm.$t("billing.packageType") },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("billing.packageType")) +
                    "\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    (_vm.planAction && _vm.plan && _vm.plan.altTitle) || "N/A"
                  ) +
                  "\n                "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "plan-detail" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      followCursor: true,
                      placement: "bottom-end",
                    },
                    expression:
                      "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                  },
                ],
                attrs: { content: _vm.$t("billing.packagePeriod") },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("billing.packagePeriod")) +
                    "\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    (_vm.planAction &&
                      _vm.formatPeriod(_vm.planAction.period)) ||
                      "N/A"
                  ) +
                  "\n                "
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.type === "chatbot"
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        followCursor: true,
                        placement: "bottom-end",
                      },
                      expression:
                        "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                }",
                    },
                  ],
                  staticClass: "plan-detail",
                  attrs: { content: _vm.$t("billing.maxChatbotSession") },
                },
                [
                  _c("div", [_vm._v(_vm._s(_vm.$t("billing.chatbotLimit")))]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.features.totalSessionCount))]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.type == "supsis"
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        followCursor: true,
                        placement: "bottom-end",
                      },
                      expression:
                        "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                }",
                    },
                  ],
                  staticClass: "plan-detail",
                  attrs: { content: _vm.$t("message.agentCount") },
                },
                [
                  _c("div", [_vm._v(_vm._s(_vm.$t("message.agentCount")))]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.features.maxAgentCount || 1) +
                        "\n                    "
                    ),
                    _vm.features.freeAgentCount > 0
                      ? _c("div", [
                          _vm._v(
                            "\n                        (" +
                              _vm._s(_vm.features.freeAgentCount) +
                              " " +
                              _vm._s(_vm.$t("billing.free")) +
                              ")\n                    "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "whatsapp" || _vm.type === "whatsapp-business"
            ? _c("div", { staticClass: "plan-detail" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                      },
                    ],
                    attrs: { content: _vm.$t("billing.channelCount") },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("billing.channelCount")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.type === "whatsapp"
                          ? _vm.features.maxWhatsappChannel
                          : _vm.features.maxBusinessWhatsappChannel || "N/A"
                      ) +
                      "\n                "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "instagram"
            ? _c("div", { staticClass: "plan-detail" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                      },
                    ],
                    attrs: { content: _vm.$t("billing.channelCount") },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("billing.channelCount")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.features.maxInstagramChannel || 0) +
                      "\n                "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "messenger"
            ? _c("div", { staticClass: "plan-detail" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                      },
                    ],
                    attrs: { content: _vm.$t("billing.channelCount") },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("billing.channelCount")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.features.maxMessengerChannel || 0) +
                      "\n                "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "meta-lead"
            ? _c("div", { staticClass: "plan-detail" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                      },
                    ],
                    attrs: { content: _vm.$t("billing.channelCount") },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("billing.channelCount")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.features.maxMetaLeadChannel || 0) +
                      "\n                "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "automation"
            ? _c("div", { staticClass: "plan-detail" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                      },
                    ],
                    attrs: { content: "Automation Tasks" },
                  },
                  [
                    _vm._v(
                      "\n                    Automation Tasks\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.features.maxAutomationTask || 0) +
                      "\n                "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "trendyol"
            ? _c("div", { staticClass: "plan-detail" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                      },
                    ],
                    attrs: { content: _vm.$t("billing.channelCount") },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("billing.channelCount")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.features.maxTrendyolChannel || 0) +
                      "\n                "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "webphone"
            ? _c("div", { staticClass: "plan-detail" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                      },
                    ],
                    attrs: { content: _vm.$t("billing.channelCount") },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("billing.channelCount")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.features.maxWebphoneChannel || 0) +
                      "\n                "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.planAction && _vm.planAction.period === "forever"
            ? _c("div", { staticClass: "plan-detail" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                      },
                    ],
                    attrs: { content: _vm.$t("billing.remainingTime") },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("billing.remainingTime")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", [_vm._v("∞")]),
              ])
            : !_vm.detailPackage().enabled
            ? _c("div", { staticClass: "plan-detail" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                      },
                    ],
                    attrs: { content: _vm.$t("billing.remainingTime") },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("billing.remainingTime")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", [_vm._v("N/A")]),
              ])
            : !_vm.detailPackage().renewed
            ? _c("div", { staticClass: "plan-detail" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                      },
                    ],
                    attrs: { content: _vm.$t("billing.remainingTime") },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("billing.remainingTime")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm._v(_vm._s(_vm.detailPackage().leftTime) + " gün"),
                ]),
              ])
            : _vm.detailPackage().renewed
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: {
                        followCursor: true,
                        placement: "bottom-end",
                      },
                      expression:
                        "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                }",
                    },
                  ],
                  staticClass: "plan-detail",
                  attrs: { content: _vm.$t("billing.renewalDate") },
                },
                [
                  _c("div", [_vm._v(_vm._s(_vm.$t("billing.renewalDate")))]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.detailPackage().endDate))]),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "image" },
          [_c("DynamicSvg", { attrs: { name: _vm.getIcon(_vm.type) } })],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }